/**
 * OrbDocCoreConceptsPagesARDocEx1LibraryPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsPagesARDocEx1LibraryPage
 */

import { useOrbDocCoreConceptsPagesARDocEx1LibraryPageLogic } from '@/hooks/traits/useOrbDocCoreConceptsPagesARDocEx1LibraryPageLogic';
import type { OrbDocCoreConceptsPagesARDocEx1LibraryPageConfig } from '@/hooks/traits/useOrbDocCoreConceptsPagesARDocEx1LibraryPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsPagesARLibraryView as OrbDocCoreConceptsPagesARLibraryViewEntity } from '@app/shared';
import { OrbDocCoreConceptsPagesARBookFactsView } from '@/components/traits/OrbDocCoreConceptsPagesARBookFactsView';
import { OrbDocCoreConceptsPagesARBookShelfView } from '@/components/traits/OrbDocCoreConceptsPagesARBookShelfView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsPagesARDocEx1LibraryPageViewProps {
  config?: Partial<OrbDocCoreConceptsPagesARDocEx1LibraryPageConfig>;
}

export function OrbDocCoreConceptsPagesARDocEx1LibraryPageView({ config: propsConfig }: OrbDocCoreConceptsPagesARDocEx1LibraryPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsPagesARDocEx1LibraryPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsPagesARLibraryView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsPagesAR" trait="OrbDocCoreConceptsPagesARDocEx1LibraryPage">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="lg"><OrbDocCoreConceptsPagesARBookFactsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsPagesARBookShelfView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsPagesARDocEx1LibraryPageView;
